var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMessageSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.2 21.82-1.5-2a.377.377 0 0 0-.21-.1H8c-4.17 0-6.75-1.13-6.75-6.75v-5c0-4.42 2.33-6.75 6.75-6.75h8c4.42 0 6.75 2.33 6.75 6.75v5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-5c0-3.58-1.67-5.25-5.25-5.25H8c-3.58 0-5.25 1.67-5.25 5.25v5c0 4.52 1.55 5.25 5.25 5.25h.5c.51 0 1.1.29 1.4.7l1.5 2c.35.46.85.46 1.2 0a.75.75 0 0 1 1.2.9c-.46.61-1.11.96-1.8.96s-1.34-.35-1.8-.96z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10.97c0-.55.45-1 1-1s1 .45 1 1-.44 1-1 1-1-.45-1-1zM15 10.97c0-.55.45-1 1-1s1 .45 1 1-.44 1-1 1-1-.45-1-1zM7 10.97c0-.55.45-1 1-1s1 .45 1 1-.44 1-1 1-1-.45-1-1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.2c0-2.18 1.77-3.95 3.95-3.95s3.95 1.77 3.95 3.95-1.77 3.95-3.95 3.95-3.95-1.77-3.95-3.95zm1.5 0c0 1.35 1.1 2.45 2.45 2.45s2.45-1.1 2.45-2.45-1.1-2.45-2.45-2.45-2.45 1.1-2.45 2.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.47 22.53-1-1a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1 1c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMessageSearch);
export default __webpack_public_path__ + "static/media/vuesax-outline-message-search.ce299b18f630886538140146929bda1c.svg";
export { ForwardRef as ReactComponent };